import { createContext, useContext, type ReactNode } from "react";
import { createPortal } from "react-dom";

/**
 * The shell reserves a full-height column to the right of the scrolling
 * content region. Pages render into it through `DetailsPanel` so the panel
 * is a sibling of the content — full height, with its own scroll — rather
 * than something nested inside the page's padding.
 *
 * The host collapses when nothing is rendered into it, and is hidden below
 * the panel breakpoint; pages should render a Drawer at that size instead.
 */
const PanelHostContext = createContext<HTMLElement | null>(null);

export const PanelHostProvider = PanelHostContext.Provider;

export function usePanelHost(): HTMLElement | null {
  return useContext(PanelHostContext);
}

export function DetailsPanel({ children }: { children: ReactNode }) {
  const host = usePanelHost();
  return host ? createPortal(children, host) : null;
}
